import { AxiosProgressEvent } from "axios";
import { StrapiMedia, StrapiMediaEntity } from "~/shared-types";
import { strapiClient } from "~/strapi/api";

export type FileToUpload = File & {
  upload?: AxiosProgressEvent | null;
};

export type MediaFile = FileToUpload | StrapiMedia;

export async function uploadFiles(
  files: FileToUpload[],
  onProgress: (progressEvent: AxiosProgressEvent, file: FileToUpload) => void
) {
  const fileUploads = files.map((file) => {
    const formData = new FormData();
    formData.append("files", file);

    return strapiClient.post<StrapiMediaEntity[]>("/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (e) => onProgress(e, file),
      onDownloadProgress: (e) => onProgress(e, file),
    });
  });

  const responses = await Promise.all(fileUploads);
  console.log("Upload responses:", JSON.stringify(responses.map(r => r.data)));

  const uploadedFiles = responses.flatMap((response) => response.data);

  const unentitizedFiles = uploadedFiles.flatMap((file) => {
    const { id, ...attributes } = file;
    const strapiMedia = { id, attributes };
    return strapiMedia;
  });

  console.log("Unentitized:", JSON.stringify(unentitizedFiles));
  return unentitizedFiles as StrapiMedia[];
}
